const Layout = () => import('@/layout/index.vue')

export default {
    path: '/home',
    component: Layout,
    redirect: '/home/index',
    name: 'Home',
    meta: {
        title: '首页',
        icon: 'home'
    },
    children: [
        {
            path: 'index',
            name: 'HomeIndex',
            component: () => import('@/views/home/index.vue'),
            meta: {
                title: '首页',
                sidebar: false,
                breadcrumb: false,
                activeMenu: '/home',
                auth: ['home']
            }
        }
    ]
}
